import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HelpLayout } from "./components/HelpLayout";
import { HelpSearch } from "./components/HelpSearch";
import { GuideCard } from "./components/GuideCard";
import { getAllGuides } from "../../lib/help/loadGuides";
import { HELP_CATEGORIES } from "../../lib/help/types";

export function GuidesIndex() {
  const guides = getAllGuides();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash]);

  return (
    <HelpLayout crumbs={[{ label: "Guides" }]}>
      <div className="help-heading mb-12">
        <h1 className="font-display text-4xl font-bold text-bark-900">Guides</h1>
        <p className="mt-2 max-w-2xl text-lg text-bark-700">
          Step-by-step walkthroughs for everything BookBurrow can do, from first install to year-end.
        </p>
        <div className="mt-6 max-w-2xl">
          <HelpSearch />
        </div>
      </div>

      <div className="grid gap-10 lg:grid-cols-[220px_1fr]">
        <aside className="hidden lg:block">
          <nav className="sticky top-24">
            <p className="mb-3 font-semibold uppercase tracking-wider text-bark-600 text-xs">
              Categories
            </p>
            <ul className="space-y-2">
              {HELP_CATEGORIES.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={`#${cat.id}`}
                    className="block rounded-lg px-3 py-1.5 text-sm text-bark-700 transition-colors hover:bg-cream-100 hover:text-forest-700"
                  >
                    {cat.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <div className="space-y-14">
          {HELP_CATEGORIES.map((cat) => {
            const catGuides = guides.filter((g) => g.frontmatter.category === cat.id);
            if (!catGuides.length) return null;
            return (
              <section key={cat.id} id={cat.id} className="scroll-mt-24">
                <h2 className="font-display text-2xl font-semibold text-bark-900">{cat.title}</h2>
                <p className="mt-1 text-bark-700">{cat.description}</p>
                <div className="mt-5 grid gap-4 sm:grid-cols-2">
                  {catGuides.map((g) => (
                    <GuideCard key={g.frontmatter.slug} guide={g.frontmatter} />
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </HelpLayout>
  );
}
